export default "__VITE_ASSET__34d6e2f9__"